import { Container, Box } from '@chakra-ui/react';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

function AdminLayout({ children }: Props) {

  return (
    <Box padding="5">
      {children}
    </Box>
  );
}

AdminLayout.defaultProps = {
};

export default AdminLayout;